import React, { useEffect, useState } from "react";
import DashboardContent from "./DashboardContent";

export default function DashboardPage({ isDarkMode }) {
  const [devices, setDevices] = useState([]);
  const API_DASHBOARD_URL = "https://holmio.net/app/api_dashboard.php";

  useEffect(() => {
    const userId = localStorage.getItem("userId"); // Corrige: en App.js guardas userId
    if (userId) {
      fetch(`${API_DASHBOARD_URL}?action=dashboard_devices&user_id=${userId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setDevices(data.data);
          } else {
            console.error("Error al cargar dispositivos:", data.message);
          }
        })
        .catch((err) => console.error("Error de red:", err));
    }
  }, []);

  const handleDownloadCode = (device) => {
    alert(`Descargar código para: ${device.name} (${device.type})`);
  };

  const handleShowCharts = (device) => {
    alert(`Mostrar gráficos para: ${device.name}`);
  };

  return (
    <DashboardContent
      devices={devices}
      isDarkMode={isDarkMode}
      onDownloadCode={handleDownloadCode}
      onShowCharts={handleShowCharts}
    />
  );
}
